import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { initialDocumentTrainingState } from "./documentTraining.types";
import {
  fetchDocumentTrainingList,
  fetchDocumentTrainingDetail,
  UPDATE_INGESTION_STATUS,
} from "./documentTrainingThunks";

const genAiKnowledgeBaseSlice = createSlice({
  name: "genAiKnowledgeBase",
  initialState: initialDocumentTrainingState,
  reducers: {
    clearDocumentTrainingState: () => {
      return initialDocumentTrainingState;
    },
    clearIngestionStatus: (state) => {
      state.ingestionStatus = null;
    },
  },
  extraReducers: (builder) => {
    // fetchDocumentTrainingList
    builder.addCase(fetchDocumentTrainingList.pending, (state) => {
      state.listLoading = LoadState.InProgress;
    });
    builder.addCase(fetchDocumentTrainingList.fulfilled, (state, action) => {
      state.listLoading = LoadState.Loaded;
      state.list = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
    });
    builder.addCase(fetchDocumentTrainingList.rejected, (state, action) => {
      state.listLoading = LoadState.Failed;
      state.error = action.payload?.message || "An error occurred";
    });

    // fetchDocumentTrainingDetail
    builder.addCase(fetchDocumentTrainingDetail.pending, (state) => {
      state.detailLoading = LoadState.InProgress;
    });
    builder.addCase(fetchDocumentTrainingDetail.fulfilled, (state, action) => {
      state.detailLoading = LoadState.Loaded;
      state.detail = action.payload;
    });
    builder.addCase(fetchDocumentTrainingDetail.rejected, (state, action) => {
      state.detailLoading = LoadState.Failed;
      state.error = action.payload?.message || "An error occurred";
    });

    // updateIngestionStatus (plain action from thunks to avoid circular import)
    builder.addMatcher(
      (action): action is PayloadAction<string> =>
        action.type === UPDATE_INGESTION_STATUS,
      (state, action) => {
        state.ingestionStatus = action.payload;
      },
    );
  },
});

export const { clearDocumentTrainingState, clearIngestionStatus } =
  genAiKnowledgeBaseSlice.actions;
export const genAiKnowledgeBaseReducer = genAiKnowledgeBaseSlice.reducer;
